import { AsyncPipe, NgIf, isPlatformServer } from '@angular/common';
import { Component, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { getFullPath } from 'src/app/lib/get-full-path';
import { GoogleOneTapService } from 'src/app/services/google-one-tap.service';
import { StateService } from 'src/app/services/state.service';
import { ResizeDirective } from 'src/app/shared/directives/resize.directive';

@Component({
  selector: 'app-google-one-tap',
  standalone: true,
  imports: [AsyncPipe, NgIf, ResizeDirective],
  templateUrl: './google-one-tap.component.html',
  styleUrl: './google-one-tap.component.scss',
})
export class GoogleOneTapComponent {
  public state = inject(StateService);
  private googeOneTapService = inject(GoogleOneTapService);
  private platformId = inject(PLATFORM_ID);
  private route = inject(ActivatedRoute);

  private sub$ = this.googeOneTapService.showOneTap$.subscribe(showOneTap => {
    this.showOneTap = showOneTap;
    if (this.showOneTap) this.topSpacing = this.getOneTapTopSpacing();
  });

  topSpacing: number;
  showOneTap = false;

  private getOneTapTopSpacing() {
    if (isPlatformServer(this.platformId)) return 5;
    if (ScreenSizes.screenSize() === 'mobile') return 10;
    const path = getFullPath(this.route.snapshot);
    if (path[0] === 'auth') return 5;
    return 86;
  }
}
